import styled from 'styled-components';

export const StyledForm = styled.form`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.8rem;
  position: relative;
  width: 100%;
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
  width: 100%;
  flex-wrap: wrap;
`;

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
  width: 100%;
  flex: 1 1 0%;
  align-items: center;

  > div {
    width: 100%;

    > label {
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;

export const StyledButtonsGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
  padding-top: 1rem;
`;
